import React from "react";
import { useQuery } from "@tanstack/react-query";
import { Loader } from "rsuite";
import { axInst } from "../../../Components/Login/Service.jsx";
import { useSelector } from "react-redux";
import { ProgressBar } from "../ComplaintCharts/ProgressBarChart.js";
import WaterMark from "../../../Components/WaterMark/WaterMark.jsx";

const sla_alert = async (body) => {
  try {
    const res = await axInst.post("complaints/sla_breach_complaints", body);
    const data = res.data.Total_SLA_Breach_Complaints;
    return data;
  } catch (error) {
    console.error(error);
    throw error;
  }
};

export const SlaAlert = () => {
  const { data, submitted } = useSelector((state) => state.filtersComplaint);

  const {
    data: sla,
    isFetching,
    isError,
  } = useQuery({
    queryKey: ["slaaa", submitted],
    queryFn: () => sla_alert(data),
    refetchInterval: 300000,
    refetchIntervalInBackground: true,
    cacheTime: 0,
    staleTime: 0,
  });

  const allCountsZero = sla && sla.every((item) => item.SR_NUM_COUNT === 0);

  return (
    <div className="p-2 relative">
      {isFetching && (
        <div className="grid items-center justify-center w-full h-full">
          <Loader />
        </div>
      )}
      {isError && (
        <div className="grid items-center justify-center w-full h-full">
          <p>Error Occurred</p>
        </div>
      )}
      <WaterMark />
      {!isFetching && !isError && (!sla || allCountsZero) && (
        <div className="grid items-center justify-center w-full h-full mt-10">
          <p>Data not available</p>
        </div>
      )}
      {!isFetching && !isError && sla && !allCountsZero && (
        <div>
          <ProgressBar data={sla} />
        </div>
      )}
    </div>
  );
};
